import React from 'react';
import PropTypes from 'prop-types';

const styles = {
	links: { color: '#284263' },
}

const CHUrlField = ({ source, source_disp, record = {} }) => <a style={styles.links} target="_blank" title={record[source]} href={record[source]}>{record[source_disp]}</a>;

CHUrlField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default CHUrlField;


// WEBPACK FOOTER //
// ./src/utils/CHUrlField.js